import { Alert, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Formik, Form } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import PrimaryButton from "../../components/custom/PrimaryButton";
import SecondaryButton from "../../components/custom/SecondaryButton";
import TextField from "../../components/custom/TextField";
import { useMutation } from "react-query";
import { resetEmail } from "../../services/resetEmailService";

const BodyWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const StyledForm = styled(Form)`
  height: 70%;
  width: 80%;
`;

const EmailSentWrapper = styled(Box)`
  height: 70%;
  width: 80%;
`;

const TypographyWrapper = styled(Box)`
  height: 10%;
  width: 80%;
  display: flex;
  flex-direction: column;
`;

const PrimaryButtonWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  /* align-items: center; */
  margin-top: 1.5rem;
  height: 20%;
`;

function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorMessage, setΕrrorMessage] = useState("");
  const [IsEmailForgotPasswordSent, setIsEmailForgotPasswordSent] =
    useState(false);
  const [emailForSuccessScreen, setEmailForSuccessScreen] = useState("");

  const { mutate } = useMutation(resetEmail, {
    onSuccess: (data) => {
      setIsEmailForgotPasswordSent(true);
    },
    onError: (error) => {
      switch (error.response.status) {
        case 406: {
          setΕrrorMessage(
            t("User with email ") + emailForSuccessScreen + t("not found.")
          );
          break;
        }
        default: {
          setΕrrorMessage(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const initialValues = {
    userEmail: "",
  };
  let validationSchema = Yup.object().shape({
    userEmail: Yup.string()
      .email()
      .min(5, "5 characters or more")
      .required(t("Field is required")),
  });
  return (
    <BodyWrapper>
      {errorMessage && (
        <Alert sx={{ marginTop: 5, marginBottom: 5 }} severity="error">
          {errorMessage}
        </Alert>
      )}
      {!IsEmailForgotPasswordSent ? (
        <>
          <TypographyWrapper>
            <Typography variant="h5">{t("FORGOT YOUR PASSWORD")}</Typography>
            <Typography variant="h6">
              {t("We will send you an email to reset your password.")}
            </Typography>
          </TypographyWrapper>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              setEmailForSuccessScreen(values.userEmail);
              mutate(values);
            }}
          >
            {({ submitForm }) => (
              <StyledForm>
                <TextField
                  label={
                    <Typography variant="h6">{t("Email Address")}</Typography>
                  }
                  placeholder={t("user@email.com")}
                  fullWidth
                  margin="normal"
                  name="userEmail"
                  type="email"
                />
                <PrimaryButtonWrapper>
                  <PrimaryButton sx={{ height: "40%" }} onClick={submitForm}>
                    {t("SEND ME THE EMAIL")}
                  </PrimaryButton>
                </PrimaryButtonWrapper>
                <SecondaryButton
                  variant="text"
                  sx={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => navigate("/auth/sign-in")}
                >
                  {t("Back to login page")}
                </SecondaryButton>
              </StyledForm>
            )}
          </Formik>
        </>
      ) : (
        <>
          <TypographyWrapper>
            <Typography variant="h5">{t("PASSWORD RESET")}</Typography>
            <Typography variant="h6">
              {t("Instructions to reset your password have been sent to ")}
              {emailForSuccessScreen}
              {t(" email.")}
            </Typography>
          </TypographyWrapper>
          <EmailSentWrapper>
            <PrimaryButtonWrapper>
              <PrimaryButton
                sx={{ height: "40%" }}
                onClick={() => navigate("/auth/sign-in")}
              >
                {t("BACK TO LOGIN")}
              </PrimaryButton>
            </PrimaryButtonWrapper>
          </EmailSentWrapper>
        </>
      )}
    </BodyWrapper>
  );
}

export default ForgotPassword;
